module.exports = __webpack_public_path__ + "static/img/graphic.ba70ff45.svg";